export const getCountryCodeFromHrefLang = (hrefLang: string): string | null => {
  if (!hrefLang || hrefLang.toLowerCase() === 'x-default') return null;

  const hrefLangParts = hrefLang.split('-');
  if (hrefLangParts.length < 2) return null;

  return hrefLangParts[hrefLangParts.length - 1].toUpperCase();
};

export const getRedirectTarget = (fallbackSite: string, targetCountryCode: string): string => {
  const matchingAlternateLinks = Array.from(document.head.querySelectorAll<HTMLLinkElement>('link[rel="alternate"][hreflang]'))
    .filter((link) => link instanceof HTMLLinkElement)
    .filter((link) => getCountryCodeFromHrefLang(link.hreflang) === targetCountryCode.toUpperCase())
    .map((link) => link.href)
    .filter((href) => href !== '');

  return matchingAlternateLinks.length === 1 ? matchingAlternateLinks[0] : fallbackSite;
};
